import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

import {UserProvider} from "../../providers/user";
import {LoadingProvider} from "../../providers/loading";


import { FileTransfer, FileTransferObject } from '@ionic-native/file-transfer';
import { File } from '@ionic-native/file';

import { FileOpener } from '@ionic-native/file-opener';
import { InAppBrowser } from '@ionic-native/in-app-browser';
/**
 * Generated class for the JobsDetailsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-jobs-details',
  templateUrl: 'jobs-details.html',
})
export class JobsDetailsPage {
  details: any;
  pdf_path: string = 'https://app.fw-wesling.de/uploads/jobs/';

  constructor(private transfer: FileTransfer, private file: File, private fileOpener: FileOpener, public loadingProvider: LoadingProvider, private iab: InAppBrowser, public navCtrl: NavController, public navParams: NavParams, public userProvider: UserProvider) {
    this.details = this.navParams.get("details");
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad JobsDetailsPage');
  }

  openPDF(document_name,job_id, fileUrl){
    const fileTransfer: FileTransferObject = this.transfer.create();
    console.log(this.pdf_path + fileUrl);
    console.log(this.file.dataDirectory + 'jobs-'+job_id+'.pdf');

    this.loadingProvider.show();
    fileTransfer.download(this.pdf_path + fileUrl, this.file.dataDirectory + 'jobs-'+job_id+'.pdf').then((entry) => {
      this.loadingProvider.hide();
      this.fileOpener.open(entry.toURL(), 'application/pdf')
          .then(() => console.log('File is opened'))
          .catch(e => console.log('Error opening file', e));
    }, (error) => {
      // handle error
    });
  }


  openWebsite(link: string) {
    this.iab.create(link, '_blank');
  }


}



// WEBPACK FOOTER //
// ./src/pages/jobs-details/jobs-details.ts